import store from '../redux/Store'
import {error, success} from "./Toast";
import Objects from "../redux/Objects";
import {sessionDestroy} from "../history/Session";
import {history} from "../history/History";


export function fetchFile(url, params, onSuccess, onFailure) {
    let token = store.getState().param[Objects.token]

    params = {
        ...params,
        token: token
    }

    const formData = new FormData()
    let keyParam = Object.keys(params)

    for (let key of keyParam) {
        formData.append(key, params[key])
    }

    fetch(window.baseAPI + url, {
        method: "POST",
        body: formData
    }).then((response) => response.json())
        .then((result) => {
            // store.dispatch(set(Objects.connectionError, false))

            if (!result.success) {
                if (result.code && result.code === -1) {
                    if (window.sessionLoaded)
                        sessionDestroy()
                    history.push('/hom/login')
                }

                if (onFailure) {
                    if (result.code) {
                        onFailure(result.code)
                    } else {
                        onFailure()
                    }
                }
                return
            }
            if (onSuccess)
                onSuccess({data: result})
        })
        .catch(() => {
            error("You are not connected to the Internet")
            if (onFailure)
                onFailure()
        });
}

export function fetchWithToken(url, method, params, onSuccess, onFailure, showMsg) {
    let token = store.getState().param[Objects.token]

    params = {
        ...params,
        token: token
    }
    fetch(window.baseAPI + url + "?" + new URLSearchParams(params).toString(), {
        method: method,
    }).then((response) => response.json())
        .then((result) => {
            // store.dispatch(set(Objects.connectionError, false))

            if (result.description && result.description !== "" && (showMsg === undefined || showMsg)) {
                if (result.success)
                    success(result.description)
                else
                    error(result.description)
            }

            if (!result.success) {
                if (result.code && result.code === -1) {
                    if (window.sessionLoaded)
                        sessionDestroy()
                    history.push('/hom/login')
                }

                if (onFailure) {
                    if (result.code) {
                        onFailure(result.code)
                    } else {
                        onFailure()
                    }
                }
                return
            }
            if (onSuccess)
                onSuccess(result.data)
        })
        .catch((err) => {
            error("You are not connected to the Internet")
            if (onFailure)
                onFailure()
        });
}

export function fetchApi(url, method, params, onSuccess, onFailure, showMsg) {

    fetch(window.baseAPI + url + "?" + new URLSearchParams(params).toString(), {
        method: method,
    }).then((response) => response.json())
        .then((result) => {

            if (result.description && result.description !== "" && (showMsg === undefined || showMsg)) {
                if (result.success)
                    success(result.description)
                else
                    error(result.description)
            }

            if (!result.success) {
                if (result.code && result.code === -1) {
                    if (window.sessionLoaded)
                        sessionDestroy()
                    history.push('/hom/login')
                }

                if (onFailure) {
                    if (result.code) {
                        onFailure(result.code)
                    } else {
                        onFailure()
                    }
                }
                return
            }
            if (onSuccess)
                onSuccess(result.data)
        })
        .catch(() => {
            error("You are not connected to the Internet")

            // store.dispatch(set(Objects.connectionError, true))

            if (onFailure)
                onFailure()
        });

}
